/**
 * alertRuleOperationLog模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const alertRuleOperationLog = {
  //报警规则日志查询
  listOperationLogByAlertRuleId(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/alertRuleOperationLog/listOperationLogByAlertRuleId`,param);
  }
}

export default alertRuleOperationLog;



// WEBPACK FOOTER //
// ./src/api/alertRuleOperationLog.js